import React, { useEffect } from "react";
import { Polyline, useMap } from "react-leaflet";

function ErrorLine(props) {
  const map = useMap();

  useEffect(() => {
    map.flyToBounds([props.guess, props.actualPoint], {
      padding: [200, 200],
      duration: 1.0,
    });
  }, [map, props.guess, props.actualPoint]);

  return (
    <>
      <Polyline
        positions={[props.guess, props.actualPoint]}
        pathOptions={{ color: "red", dashArray: 10 }}
      />
    </>
  );
}

export default ErrorLine;
